import { call, put } from 'redux-saga/effects';

import { updateSavedFilingPeriodByIdSuccess } from '@actions/savedFilingPeriod';
import { updateSavedFilingPeriodById } from '@api/savedFilingPeriod';

export const updateFilingByIdRequest = function* ({ payload }) {
  const response = yield call(updateSavedFilingPeriodById, payload);

  yield put(updateSavedFilingPeriodByIdSuccess(response));

  if (payload?.onSuccess) {
    yield call(payload.onSuccess, response);
  }
};
